import { Box, Stack, styled } from '@mui/material';
import { colors } from '@watter/shared-components';

export const focuseEffect = () => ({
    content: "''",
    background:
        'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: -1,
    inset: 0,
    borderRadius: '28px',
    transform: 'scale(1.02, 1.06)',
});
export const HeaterDetailWrapper = styled(Box)(({ theme }) => ({
    background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.white,
    boxShadow: '0px 0px 30px 0px #0000001A',
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-start',
    columnGap: theme.spacing(3),
    height: 'calc(100dvh - 160px)',
    overflow: 'auto',
    rowGap: theme.spacing(2.5),
    '& form': {
        display: 'grid',
        gridTemplateColumns: '1fr 35%',
        gap: theme.spacing(3),
        zIndex: 0,
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column-reverse',
            gap: theme.spacing(1),
        },
    },

    '& .contactUs': {
        '& .infoBox': {
            background: theme.palette.mode === 'dark' ? colors.blackColor : colors.whiteSmoke,
            padding: theme.spacing(5),
            borderRadius: theme.spacing(1.25),
            '& .MuiTypography-root': {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(1),
                fontFamily: 'good_sansregular',
                '& .MuiLink-root': {
                    color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
                    marginBottom: 0,
                    '&.cstLink': {
                        color: '#2FABE1',
                    },
                },
            },
        },
        [theme.breakpoints.down(1200)]: {
            flexDirection: 'column-reverse',
            '& .infoBox': {
                marginTop: theme.spacing(1.5),
                padding: theme.spacing(2),
                '& .MuiTypography-root': {
                    marginBottom: theme.spacing(1.5),
                },
            },
            '& img': {
                width: '35%',
            },
        },
        '& .cstHeaterName': {
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: theme.palette.mode === 'dark' ? colors.lightHead : colors.lightGray, // default border
                    borderBottomWidth: 2,
                },
                '&:hover fieldset': {
                    borderColor: theme.palette.mode === 'dark' ? colors.lightHead : colors.lightGray, // optional: hover color
                    borderBottomWidth: 2,
                },
                '&.Mui-focused fieldset': {
                    borderColor: theme.palette.mode === 'dark' ? colors.lightHead : colors.lightGray,
                    borderBottomWidth: 2,
                },
            },

            '& .MuiInputBase-input': {
                color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
                '-webkit-text-fill-color': 'inherit',
            },
        },
    },
    '& .cstSlider': {
        '& .MuiSlider-root': {
            height: theme.spacing(1),
            background: theme.palette.mode === 'dark' ? colors.lightHead : colors.lightGray,
            padding: 0,
            margin: theme.spacing(2, 0),
            '& .MuiSlider-rail': {
                height: theme.spacing(0.5),
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 10%, #B3E3F3 20%, #FDCC3F 40%, #FF8524 60%, #E03C23 80%, #441212 100%)',
                opacity: 1,
                marginHorizontal: '5px',
            },
            '& .MuiSlider-track': {
                background: 'transparent',
                border: 'none',
            },
            '& .MuiSlider-mark': {
                background: 'transparent',
            },
            '& .MuiSlider-markLabel': {
                color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
                top: theme.spacing(2.25),
                fontSize: theme.spacing(1),
                fontFamily: 'good_sansbold',
            },
            '& .MuiSlider-markLabel[data-index="0"]': {
                left: '2% !important',
            },
            '& .MuiSlider-markLabel[data-index="1"]': {
                left: '98% !important',
            },
            '& .MuiSlider-thumb': {
                background: 'linear-gradient(320.66deg, rgb(20, 21, 21) 14.75%, rgb(46, 50, 54) 84.81%)',
                boxShadow: 'none',
                '&:before': {
                    width: '40%',
                    height: '40%',
                    background: colors.SliderThumb,
                },
                '& .MuiSlider-valueLabelOpen': {
                    background: 'transparent',
                    padding: 0,
                    top: 0,
                    fontFamily: 'good_sansbold',
                    color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
                },
            },
        },
    },
    '& .cstTextFeild': {
        position: 'relative',
        '& .MuiInputBase-root': {
            '& .MuiInputBase-input': {
                padding: theme.spacing(2.0625, 0),
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: '0px 0px 1px 0px',
                borderRadius: 0,
            },
            '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'none',
                },
            },
        },
        '& .cstEdit': {
            position: 'absolute',
            top: theme.spacing(5.875),
            right: 0,
        },
    },
    '& .cstModifyBtn': {
        fontSize: theme.spacing(1.25),
        background: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
        color: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
        padding: theme.spacing(0.375),
    },
    '& .cstCancelBtn': {
        fontSize: theme.spacing(1.25),
        background: colors.lightRed,
        color: colors.white,
        padding: theme.spacing(0.375),
    },
    '& .cstActionBtns': {
        '& .cstBtnWrapper': {
            '& .MuiButtonBase-root': {
                padding: 0,
                zIndex: 1,
                '& .MuiStack-root': {
                    padding: theme.spacing(1.75, 2),
                    borderRadius: theme.spacing(2),
                    background: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
                    width: '100%',
                },
            },
            position: 'relative',
            padding: theme.spacing(0.125),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            borderRadius: theme.spacing(2),
            '&.cstActiveBtn': {
                height: '100%',
                '&::after': {
                    ...focuseEffect(),
                    zIndex: 0,
                    borderRadius: theme.spacing(2),
                },
                '& .active': {
                    color: colors.verifyText,
                },
            },
        },
    },
    '& .cstImgContainer': {
        position: 'relative',
        '&::after': {
            position: 'absolute',
            height: '100%',
            width: '100%',
            rotate: '180deg',
        },
    },
}));
export const NotifyContainer = styled(Stack)(({ theme }) => ({
    '& .cards': {
        borderRadius: theme.spacing(1),
        background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.whiteSmoke,
        '& .unread': {
            width: theme.spacing(1.75),
            height: theme.spacing(1.75),
            borderRadius: '50%',
            background: colors.verifyText,
        },
        '& .MuiSvgIcon-root[data-testid="DeleteIcon"]': {
            color: theme.palette.mode === 'dark' ? colors.white : colors.gray,
        },
        '& .subText': {
            color: theme.palette.mode === 'dark' ? colors.info : colors.lightHead,
        },
    },
}));
